export interface LetterRequestCustomer_Order_Interface {
  id:number,
  title:String,
  cls:String,
  icon:String,
  section_id:Number,
  hasRefer:boolean,
  submit:boolean,
  copy:boolean,
  role_id:String,
  goSection:Number,
}

export function Empty_LetterRequestCustomer_Order_Interface():LetterRequestCustomer_Order_Interface{
  return{
    id:0,
    title:'',
    cls:'',
    icon:'',
    section_id:0,
    hasRefer:false,
    submit:false,
    copy:false,
    role_id:'',
    goSection:0,
  }
}
